import {
  Button,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Tooltip,
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  StyledTableCell,
  StyledTableHeadRow,
  StyledTableRow,
} from "./ProjectsTable";
import { motion } from "framer-motion";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import {
  deleteStack,
  fetchStacks,
  editStack,
} from "../features/stacks/stacksSlice";
import { iconButtonStyle } from "../utils/iconButtonStyle";
import DeleteForeverTwoToneIcon from "@material-ui/icons/DeleteForeverRounded";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import Loader from "react-loader-spinner";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import IStack from "../interface/IStack";
import { useStyles } from "./ProjectTimeline";
import CloseRounded from "@material-ui/icons/CloseRounded";

const buttonHover = {
  scale: 1.1,
  transition: { duration: 0.3 },
  boxShadow: "1px 1px 7px",
};
const buttonTap = { scale: 0.9 };

interface EditStackPropProps {
  handleClick: () => void;
}

export default function EditStackProp({
  handleClick,
}: EditStackPropProps): JSX.Element {
  const dispatch = useAppDispatch();
  const classes = useStyles();

  useEffect(() => {
    dispatch(fetchStacks());
  }, [dispatch]);

  const stacks = useAppSelector((state) => state.stacks);

  const { data: stacksList, isSuccess, isFetching } = stacks;

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<IStack>();

  const [currentStack, setCurrentStack] = useState<IStack>();

  const onSubmit: SubmitHandler<IStack> = (data) => {
    currentStack && (data.id = currentStack.id);
    dispatch(editStack(data));
    handleClose();
  };

  const findCurrentStack = (id: number): void =>
    setCurrentStack(stacksList.find((elem) => elem.id === id));

  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [stackToDelete, setStackToDelete] = useState<number>();
  const handleDialogClose = () => setDialogOpen(false);
  const handleDialogOpen = () => setDialogOpen(true);

  return (
    <div>
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Czy napewno chcesz usunąć projekt?"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleDialogClose}>Nie</Button>
          <Button
            onClick={() => {
              dispatch(deleteStack(stackToDelete!));
              handleDialogClose();
            }}
            autoFocus
          >
            Tak
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="Stack editor"
        aria-describedby="Edit projects stack"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Paper
            className={classes.modalStyle}
            style={{
              position: "relative",
              minHeight: "250px",
              minWidth: "300px",
              maxWidth: "400px",
              margin: "4rem auto",
            }}
          >
            <Grid container justifyContent="center">
              <Grid item>
                <Typography variant="h3" color="primary" align="center">
                  Technologia
                </Typography>
                <Controller
                  name={`label`}
                  shouldUnregister
                  control={control}
                  rules={{ required: true }}
                  defaultValue={currentStack?.label}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      style={{ width: "100%", padding: 0 }}
                      margin="normal"
                      variant="outlined"
                      placeholder="Technologia"
                      label="Technologia"
                      error={Boolean(errors?.label)}
                      helperText={errors?.label && "Podaj nową wartość."}
                    />
                  )}
                />
              </Grid>
              <Grid container>
                <Button
                  color="primary"
                  variant="contained"
                  style={{ margin: "1rem auto" }}
                  type="submit"
                >
                  Zatwierdź
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </form>
      </Modal>
      {stacksList && isSuccess ? (
        <>
          <TableContainer component={Paper} style={{ margin: "1rem auto" }}>
            <Button
              color="secondary"
              style={{
                position: "absolute",
                right: "0",
              }}
              onClick={() => handleClick()}
            >
              <CloseRounded />
            </Button>
            <Table>
              <TableHead>
                <StyledTableHeadRow>
                  <StyledTableCell align="center" size="small">
                    ID
                  </StyledTableCell>
                  <StyledTableCell align="center">Technologia</StyledTableCell>
                  <StyledTableCell align="center">Akcje</StyledTableCell>
                </StyledTableHeadRow>
              </TableHead>
              <TableBody>
                {stacksList.map(({ id, label }) => {
                  return (
                    <StyledTableRow key={id}>
                      <TableCell align="center" size="small">
                        {id}
                      </TableCell>
                      <TableCell align="center">{label}</TableCell>
                      <TableCell align="center">
                        <Tooltip title="usuń" placement="top" arrow>
                          <IconButton
                            component={motion.div}
                            whileHover={buttonHover}
                            whileTap={buttonTap}
                            id={`${id}`}
                            onClick={() => {
                              setStackToDelete(id);
                              handleDialogOpen();
                            }}
                            style={iconButtonStyle("#d32f2f")}
                          >
                            <DeleteForeverTwoToneIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="edytuj" placement="top" arrow>
                          <IconButton
                            component={motion.div}
                            whileHover={buttonHover}
                            whileTap={buttonTap}
                            id={`${id}`}
                            onClick={() => {
                              findCurrentStack(id);
                              handleOpen();
                            }}
                            style={iconButtonStyle("#ff9800")}
                          >
                            <EditRoundedIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : isFetching ? (
        <div style={{ margin: "8rem auto" }}>
          <h3>Pobieram listę technologii</h3>
          <Loader type="TailSpin" />
        </div>
      ) : (
        <h2 style={{ margin: "0 auto" }}>Brak technologii do wyświetlenia</h2>
      )}
    </div>
  );
}
